import * as APIUtils from '@components/Globals/Utils';
import cloneDeep from 'lodash.clonedeep';
import { socketService } from '@/services/socketService';

// Interfaces
interface RequestApi {
  url: string;
  token: string;
  // otras propiedades específicas
}

interface FavoriteParams {
  replyId: number;
  [key: string]: any;
}

interface AddReplyParams {
  CopyBody: string;
  Body?: string;
  type?: number;
  ReplyId_Repost?: number;
  ReplyId?: number;
  [key: string]: any;
}

interface UpdateReplyParams {
  CopyBody: string;
  Body?: string;
  [key: string]: any;
}

interface DeleteReplyParams {
  replyId: number;
  [key: string]: any;
}

interface ReplyReactionPayload {
  replyId: number;
  reactionType: string;
  userId?: number;
  [key: string]: any;
}

// Clase API
class ReplyApi
{
  /**
   * Marca una respuesta como favorita
   */
  static async markAsFavorite(requestApi: RequestApi, requestParams: FavoriteParams): Promise<any>
  {
    return APIUtils.callFetch(
      requestApi,
      'api/reply/MarkAsFavorite',
      'PUT',
      { ...requestParams, SocketConnectionId: socketService.connectionId },
      true,
    );
  }

  /**
   * Desmarca una respuesta como favorita
   */
  static async markAsUnfavorite(
    requestApi: RequestApi,
    requestParams: FavoriteParams,
  ): Promise<any>
  {
    return APIUtils.callFetch(
      requestApi,
      'api/reply/MarkAsUnfavorite',
      'PUT',
      { ...requestParams, SocketConnectionId: socketService.connectionId },
      true,
    );
  }

  /**
   * Agrega una nueva respuesta o repost
   */
  static async addReply(requestApi: RequestApi, requestParams: AddReplyParams): Promise<any>
  {
    const copyRequest = cloneDeep(requestParams);
    copyRequest.Body = copyRequest.CopyBody;

    let url = 'api/reply';

    if (requestParams.type === 2)
    {
      url = 'api/reply/repost/';
      copyRequest.ReplyId = copyRequest.ReplyId_Repost;
    }

    return APIUtils.callFetch(requestApi, url, 'POST', {
      ...copyRequest,
      SocketConnectionId: socketService.connectionId,
    });
  }

  /**
   * Actualiza una respuesta existente
   */
  static async updateReply(requestApi: RequestApi, requestParams: UpdateReplyParams): Promise<any>
  {
    const copyRequest = cloneDeep(requestParams);
    copyRequest.Body = copyRequest.CopyBody;

    return APIUtils.callFetch(requestApi, 'api/reply/update', 'POST', {
      ...copyRequest,
      SocketConnectionId: socketService.connectionId,
    });
  }

  /**
   * Elimina una respuesta
   */
  static async deleteReply(requestApi: RequestApi, requestParams: DeleteReplyParams): Promise<any>
  {
    return APIUtils.callFetch(
      requestApi,
      'api/reply/RemoveReply',
      'PUT',
      { ...requestParams, SocketConnectionId: socketService.connectionId },
      true,
    );
  }

  /**
   * Obtiene una respuesta por su ID
   */
  static async getReplyById(
    requestApi: RequestApi,
    replyId: number,
    downloadTempFiles: boolean,
  ): Promise<any>
  {
    const params = `?replyId=${replyId}&downloadTempFiles=${downloadTempFiles}`;
    return APIUtils.callFetch(requestApi, `api/reply/getreplybyid${params}`, 'GET');
  }

  /**
   * Inserta una nueva reacción a una respuesta
   */
  static async insertReplyReaction(
    requestApi: RequestApi,
    requestPayload: ReplyReactionPayload,
  ): Promise<any>
  {
    return APIUtils.callFetch(requestApi, 'api/Reply/InsertReplyReaction', 'POST', {
      ...requestPayload,
      SocketConnectionId: socketService.connectionId,
    });
  }

  /**
   * Actualiza una reacción existente
   */
  static async updateReplyReaction(
    requestApi: RequestApi,
    requestPayload: ReplyReactionPayload,
  ): Promise<any>
  {
    return APIUtils.callFetch(requestApi, 'api/Reply/UpdateReplyReaction', 'POST', {
      ...requestPayload,
      SocketConnectionId: socketService.connectionId,
    });
  }

  /**
   * Elimina una reacción de una respuesta
   */
  static async deleteReplyReaction(
    requestApi: RequestApi,
    requestPayload: ReplyReactionPayload,
  ): Promise<any>
  {
    return APIUtils.callFetch(requestApi, 'api/Reply/DeleteReplyReaction', 'POST', {
      ...requestPayload,
      SocketConnectionId: socketService.connectionId,
    });
  }
}

export default ReplyApi;
